import { render, staticRenderFns } from "./DealDrawer.vue?vue&type=template&id=1f28adf6&"
import script from "./DealDrawer.vue?vue&type=script&lang=js&"
export * from "./DealDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports